import { Grid } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';
import React, { FunctionComponent, useState } from 'react';
import MembershipRow from './MembershipRow';
import { useCommonStyles } from './CommonStyles';
import { Membership } from '@spike/membership-model';
import { wbp, reduceResolution } from 'Theme';
import TableHeaderDetail from './TableHeaderDetail';
import MembershipItem from './MembershipItem';

interface TableBodyProps {
    memberships: Array<Membership>;
    onEditMembership?: (membershipId: number) => void;
    onSelectMembership: (membership: Membership) => void;
    onChangeStatus: (membershipId: number, isActive: boolean) => void;
}

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        row: {
            backgroundColor: 'white',
            borderBottom: '1px solid #F1F1F1',

            [theme.breakpoints.down('sm')]: {
                padding: '12px 16px'
            },
            [theme.breakpoints.up('md')]: {
                borderLeft: '4px solid white',
                borderBottom: '1px solid #DDDDDD'
            }
        },
        expandedMembershipRow: {
            borderLeft: '4px solid #BAA997',
            borderBottom: '1px solid white',
            backgroundColor: '#F8F5F1'
        },
        membershipRow: {
            borderLeft: '4px solid #BAA997',
            [theme.breakpoints.down(wbp)]: {
                boxShadow: `0px ${reduceResolution(5)}px ${reduceResolution(12)}px rgba(0, 0, 0, 0.08)`,
                marginBottom: `${reduceResolution(12)}px`
            },
            [theme.breakpoints.up(wbp)]: {
                boxShadow: '0px 5px 12px rgba(0, 0, 0, 0.08)',
                marginBottom: '12px'
            }
        }
    })
);

const TableBody: FunctionComponent<TableBodyProps> = props => {
    const classes = useStyles();
    const commonClasses = useCommonStyles();

    const [expandedMembershipId, setExpandedMembershipId] = useState<number | null>(null);

    const handleToggle = (membershipId: number | null) => {
        setExpandedMembershipId(prev => (prev === membershipId ? null : membershipId));
    };

    return (
        <>
            {props.memberships.map(membership => (
                <>
                    <Grid
                        key={membership.uuid}
                        container
                        xs={12}
                        className={clsx(classes.row, commonClasses.rowContainer, {
                            [classes.expandedMembershipRow]: membership.id === expandedMembershipId
                        })}
                    >
                        <MembershipRow
                            membership={membership}
                            expanded={membership.id === expandedMembershipId}
                            onToggle={() => handleToggle(membership.id || null)}
                            onEdit={() => props.onEditMembership && props.onEditMembership(membership.id!)}
                            onChangeStatus={() =>
                                props.onChangeStatus && props.onChangeStatus(membership.id!, !membership.active)
                            }
                            onSelectMembership={props.onSelectMembership}
                        />
                    </Grid>
                    {membership.id === expandedMembershipId && (
                        <Grid
                            container
                            item
                            className={clsx(classes.membershipRow, commonClasses.rowContainer)}
                        >
                            <TableHeaderDetail />
                            <MembershipItem membership={membership} />
                        </Grid>
                    )}
                </>
            ))}
        </>
    );
};

export default TableBody;
